// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import TableCard from "../../../components/tablecard/TableCard";

import {GetMonitoringQuatationSpec, quatationOperasionalSelector,} from "./quatationOperasionalSlice";

import {Colors} from "../../../assets/Colors";
import {maxPageGlobal} from "../../../assets/config";

const QuatationAdditionalMonitoringPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const quatation = useSelector(quatationOperasionalSelector);

    useEffect(() => {
        dispatch(GetMonitoringQuatationSpec({
            start: start,
            count: count,
            search: '',
            jenis: 2,
        }));

    }, []);

    useEffect(() => {

        if ((search !== '') && quatation.isGetMonitoringSuccess && !quatation.isGetFetching) {
            let calc = quatation?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = quatation.dataMonitoring ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && quatation.isGetMonitoringSuccess && !quatation.isGetFetching) {
            let calc = quatation?.count - 1;

            if (calc === 0) {
                calc = 1;
            }
            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = quatation.dataMonitoring ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!quatation?.isGetFetching && quatation.isGetMonitoringSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = quatation?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = quatation.dataMonitoring ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(GetMonitoringQuatationSpec({
                start: start,
                count: count,
                search: search,
                jenis: "2",

            }));
        }


    });


    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
            jenis: 2,

        }
        dispatch(GetMonitoringQuatationSpec(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
            jenis: 2,

        }
        dispatch(GetMonitoringQuatationSpec(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (quatation.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? quatation.count : newCount,
            search: search,
        }
        dispatch(GetMonitoringQuatationSpec(params));

        setPage(1);
        setCount((newCount === "-1") ? quatation.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    // if (!firstLoading) {
    //   return <div className="md:ml-64">loading</div>
    // } else {
    return (

        <div className="md:ml-64">
            <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                <div className="container mx-auto max-w-full">
                    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                </div>
            </div>

            <div className="px-3 md:px-8 h-auto -mt-32">
                <div className="container mx-auto max-w-full">
                    <div className="grid grid-cols-1 px-4">
                        <TableCard
                            primaryID="QuatationNo"
                            editEnabled={false}
                            addButton={false}
                            quatationAdditional={true}
                            statusCustomer={false}
                            detail={true}
                            handleSearch={handleSearch}
                            searchPlaceholder="Quatation"
                            updatePage={handleUpdatePage}
                            updateCount={handleUpdateCount}
                            currentData={handleCurrentData}
                            currentPage={page}
                            maxPage={maxPage}
                            tableTitle="Master Job Request"
                            tableData={quatation.dataMonitoring}
                            colOneTitle="Nomor Quatation"
                            colOneData="QuatationNo"
                            colTwoTitle="Nomor Kontrak"
                            colTwoData="NoKontrak"
                            colThreeTitle="Expired Date"
                            colThreeData="ExpireDate"
                            colFiveTitle="Activity Choice"
                            colFiveData="ActivityChoice"
                            colSixTitle="Client"
                            colSixData="KlienID"
                            fetching={quatation.isGetFetching}
                            modal={handleModal}
                        />
                    </div>
                </div>
            </div>

        </div>

    )
    // }

}


export default QuatationAdditionalMonitoringPage;